const resources = {
  "en": {
    "invite": {
      "title": "Invite a friend",
      "description": "Share your personal invite link. Each successful registration grants you 500 points and your friend receives a free month promo code.",
      "shareSectionTitle": "Share your link",
      "shareSectionDescription": "Copy your personal invite link and send it anywhere you like.",
      "shareLinkLabel": "Your invite link",
      "linkUnavailable": "Invite link will appear after loading…",
      "copyButton": "Copy link",
      "copied": "Link copied!",
      "copyError": "Unable to copy link",
      "refreshButton": "Refresh stats",
      "sendEmailTitle": "Send email invitation",
      "sendEmailDescription": "Send the invite directly from the app when you already know their email address.",
      "emailLabel": "Friend's email",
      "emailRequired": "Enter an email address",
      "emailInvalid": "Enter a valid email address",
      "inviteePlaceholder": "friend@example.com",
      "sendButton": "Send invite",
      "statsTitle": "Your progress",
      "sentLabel": "Emails sent",
      "clicksLabel": "Link visits",
      "signupsLabel": "Successful registrations",
      "rewardLabel": "Points earned",
      "metrics": {
        "sentSupportingText": "Invite emails sent from this account",
        "clicksSupportingText": "Tracked visits to your invite link",
        "signupsSupportingText": "Successful registrations from your invite flow",
        "rewardsSupportingText": "Reward points earned from completed invites"
      },
      "recentActivity": "Recent activity",
      "recentActivityDescription": "{{count}} tracked updates from your invite link and sent emails.",
      "emptyActivity": "No invite activity yet.",
      "summaryError": "Failed to load invite data",
      "inviteEmailSuccess": "Invitation sent successfully",
      "inviteEmailError": "Failed to send invitation",
      "activity": {
        "email": "Invitation email sent to {{email}}",
        "click": "Invite link opened",
        "signup": "New user registered: {{email}}",
        "unknown": "Activity",
        "unknownTime": "Unknown time"
      },
      "howItWorksTitle": "How it works",
      "howItWorksDescription": "A simple overview of how visits, signups, and rewards are counted.",
      "howItWorksStep1": "1. Copy your invite link or send it by email to your friend.",
      "howItWorksStep2": "2. When someone opens the link we count the visit automatically.",
      "howItWorksStep3": "3. After your friend registers, you receive 500 bonus points.",
      "termsHint": "Bonus points are awarded once for each unique registration completed through your personal invite link."
    }
  },
  "uk": {
    "invite": {
      "title": "Запросити друга",
      "description": "Поділіться персональним посиланням-запрошенням. Кожна успішна реєстрація дарує вам 500 балів, а друг отримує промокод на безкоштовний місяць.",
      "shareSectionTitle": "Поділитися посиланням",
      "shareSectionDescription": "Скопіюйте персональне посилання-запрошення і надішліть його будь-яким зручним способом.",
      "shareLinkLabel": "Ваше посилання-запрошення",
      "linkUnavailable": "Посилання зʼявиться після завантаження…",
      "copyButton": "Скопіювати посилання",
      "copied": "Посилання скопійовано!",
      "copyError": "Не вдалося скопіювати посилання",
      "refreshButton": "Оновити статистику",
      "sendEmailTitle": "Надіслати запрошення електронною поштою",
      "sendEmailDescription": "Надішліть запрошення прямо з застосунку, якщо вже знаєте електронну адресу людини.",
      "emailLabel": "Електронна адреса друга",
      "emailRequired": "Введіть адресу електронної пошти",
      "emailInvalid": "Введіть коректну адресу електронної пошти",
      "inviteePlaceholder": "friend@example.com",
      "sendButton": "Надіслати запрошення",
      "statsTitle": "Ваш прогрес",
      "sentLabel": "Надіслано листів",
      "clicksLabel": "Переходи за посиланням",
      "signupsLabel": "Успішні реєстрації",
      "rewardLabel": "Нараховані бали",
      "metrics": {
        "sentSupportingText": "Листи-запрошення, надіслані з цього акаунта",
        "clicksSupportingText": "Зафіксовані переходи за вашим посиланням",
        "signupsSupportingText": "Успішні реєстрації з вашого invite flow",
        "rewardsSupportingText": "Бали, зароблені за завершені запрошення"
      },
      "recentActivity": "Остання активність",
      "recentActivityDescription": "{{count}} зафіксованих оновлень за вашим посиланням і надісланими листами.",
      "emptyActivity": "Поки що немає активності за запрошеннями.",
      "summaryError": "Не вдалося завантажити дані запрошень",
      "inviteEmailSuccess": "Запрошення успішно надіслано",
      "inviteEmailError": "Не вдалося надіслати запрошення",
      "activity": {
        "email": "Запрошення надіслано на {{email}}",
        "click": "Посилання-запрошення відкрито",
        "signup": "Новий користувач зареєструвався: {{email}}",
        "unknown": "Активність",
        "unknownTime": "Час невідомий"
      },
      "howItWorksTitle": "Як це працює",
      "howItWorksDescription": "Коротко про те, як ми рахуємо переходи, реєстрації та винагороду.",
      "howItWorksStep1": "1. Скопіюйте своє посилання-запрошення або надішліть його другу електронною поштою.",
      "howItWorksStep2": "2. Коли хтось відкриває посилання, ми автоматично фіксуємо візит.",
      "howItWorksStep3": "3. Після реєстрації друга ви отримуєте 500 бонусних балів.",
      "termsHint": "Бонусні бали нараховуються один раз за кожну унікальну реєстрацію, виконану через ваше персональне посилання-запрошення."
    }
  }
};

export default resources;
